// Facts and photos shared by the project service pages
// (ProjectServicePage.js): architectural models, art and sculpture
// fabrication (NYC and Los Angeles), metal plating, 3D signs and neon signs.
// Every fact here is a row in .seo/truth.md; anything else is "quoted per
// project". Prices come from the 3D printing data so they can't drift.
const { pricing } = require('../printing-service')
const printingNyc = require('../printing-nyc')

const photoRoot = 'https://images.ctfassets.net/dovsnf6qrcem'
const reviewedDate = '2026-11-04'

const studios =
  'Glendale, Queens (74-12 88th Street) and Brooklyn (616 Berriman Street), New York. Visits by appointment.'

// Photos already captioned on the 3D printing pages, reused here.
const printingPhotos = {
  chromeFigures: {
    ...printingNyc.photos.chrome,
    title: 'Raw print and chrome finish',
    caption:
      'The same figure straight off the printer and after chrome plating.',
  },
  goldBurger: {
    ...printingNyc.photos.burger,
    caption: 'A printed burger sculpture finished in gold plating.',
  },
  platedHands: printingNyc.photos.hands,
  atlasClock: printingNyc.photos.clocks,
}

const photo = (id, file, width, height, alt, title, caption) => ({
  url: `${photoRoot}/${id}/${file}`,
  width,
  height,
  alt,
  title,
  caption,
})

module.exports = {
  photoRoot,
  pricing,
  reviewedDate,
  studios,
  printingPhotos,
  photo,
}
